import { styled, Switch } from '@mui/material';

import { COLORS } from '../Constant/COLORS';

const IOSSwitch = styled(Switch)({
  padding: 0,
  borderRadius: '99px',
  height: '30px',
  width: '50px',
  '.MuiSwitch-switchBase': {
    transitionDuration: '200ms',
    padding: 0,
    width: '30px',
    height: '30px',
    '&.Mui-checked': {
      color: COLORS.white,
      '& + .MuiSwitch-track': {
        backgroundColor: COLORS.green4,
        opacity: 1,
      },
      '& > .MuiSwitch-thumb': {
        backgroundColor: COLORS.white,
        opacity: 1,
      },
    },
    '&.Mui-disabled': {
      '& > .MuiSwitch-thumb': {
        backgroundColor: COLORS.white3,
      },
    },
  },
  '.MuiSwitch-track': {
    transitionDuration: '400ms',
  },
  '.MuiSwitch-thumb': {
    padding: 0,
    width: '26px',
    height: '26px',
  },
});

export default IOSSwitch;
